// Suffix list mirrors normalizePlayerName in services/players/normalizeName.ts.
// "Vladimir Guerrero Jr." → "Guerrero Jr." (not bare "Jr.").
const NAME_SUFFIX_RE = /^(?:jr|sr|ii|iii|iv|v)\.?$/i;

/**
 * Last-name extractor that keeps Jr/Sr/II/III/IV/V attached. Returns null on
 * empty input so callers can branch with `?? fallbackName`.
 *
 * Examples:
 *  - "Tim Hardaway Jr." → "Hardaway Jr."
 *  - "Vladimir Guerrero Jr." → "Guerrero Jr."
 *  - "Bryson Stott" → "Stott"
 *  - "Bryson King III" → "King III"
 *  - "" / null / undefined → null
 */
export function lastName(full: string | null | undefined): string | null {
  if (!full) return null;
  const parts = full.trim().split(/\s+/);
  if (parts.length === 0) return null;
  const last = parts[parts.length - 1];
  if (!last) return null;
  if (parts.length >= 2 && NAME_SUFFIX_RE.test(last)) {
    return `${parts[parts.length - 2]} ${last}`;
  }
  return last;
}
